import './SelectIndicator.css';

import React, { useContext } from 'react';
import { Tab, Tabs } from '@mui/material';
import { TabPanel } from '../../../b2b-languages/components/helper';
import { AccountTree, InsightsOutlined } from '@mui/icons-material';
import SearchCustomIndicator from './SearchCustomIndicator';
import SearchFrameworkIndicator from './SearchFrameworkIndicator';
import { SelectIndicatorContext } from '../../pages/AreaIndicatorEditPage';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const SelectIndicator = ({ onSelectedIndicator }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const {
        selectedTab, setSelectedTab
    } = useContext(SelectIndicatorContext);

    const handleSelectedCustomIndicator = (indicator) => {
        // console.log('handleSelectedCustomIndicator: ', indicator);
        onSelectedIndicator && onSelectedIndicator(indicator);
    }

    const handleSelectedFrameworkIndicator = (indicator) => {
        // console.log('handleSelectedFrameworkIndicator: ', indicator);
        onSelectedIndicator && onSelectedIndicator(indicator);
    }

    return (
        <div className='select-indicator-assistant'>
            <div className='select-indicator-assistant-tabs-header'>
                <Tabs value={selectedTab} onChange={() => {
                    setSelectedTab(selectedTab === 0 ? 1 : 0);
                }}>
                    <Tab label={t('Custom indicators')} icon={<InsightsOutlined />} />
                    <Tab label={t('Framework indicators')} icon={<AccountTree />} />
                </Tabs>
            </div>
            <div className='select-indicator-assistant-tabs-content'>
                <TabPanel value={selectedTab} index={0}>
                    <div className='select-indicator-assistant-tab-content'>
                        <SearchCustomIndicator onSelectedCustomIndicator={handleSelectedCustomIndicator} />
                    </div>
                </TabPanel>
                <TabPanel value={selectedTab} index={1}>
                    <div className='select-indicator-assistant-tab-content'>
                        <SearchFrameworkIndicator onSelectedFrameworkIndicator={handleSelectedFrameworkIndicator} />
                    </div>
                </TabPanel>
            </div>
        </div>

    );
};

export default SelectIndicator;